import { Table, TableBody, TableHead } from '@mui/material'
import CustomTableRow from 'ui/table/CustomTableRow'
import { TableHeader } from './components'
import { useGetCellOptions } from './hooks/useGetCellOptions'
import { Limpness } from 'models/IFarm'

interface LimpnessWidgetTableProps {
	limpness: Limpness[]
	totalCattle?: number
}
export const LamenessWidgetTable = ({
	limpness,
	totalCattle = 0,
}: LimpnessWidgetTableProps) => {
	const TABLE_OPTIONS = useGetCellOptions({ limpness, totalCattle })
	return (
		<Table>
			<TableHead>
				<TableHeader />
			</TableHead>
			<TableBody>
				{TABLE_OPTIONS.map((option, index) => (
					<CustomTableRow
						key={index}
						rowKey={option.rowKey}
						cellItems={option.cellItems}
						rowHeight={option.rowHeight}
					/>
				))}
			</TableBody>
		</Table>
	)
}
